import { useContext, useEffect, useState } from 'react'
import Button from '../common/Button'
import { putRequest } from '../../services/base'
import { useParams } from 'react-router-dom'
import { NavContext } from '../../context/global_context'
import { Card, Flex, Form, Tooltip } from 'antd'
import SelectInput from '../common/SelectInput'
import { useVehicles } from '../../context/vehicle_context'
import { useIntl } from 'react-intl'

const CsvDependencies = (props) => {
  const intl = useIntl()
  const { vehicleDetails } = props
  const { make_model_id, metadata } = vehicleDetails

  const { vehicle } = useParams()
  const [selectedValue, setSelectedValue] = useState({})
  const [state, dispatch] = useContext(NavContext)
  const [form] = Form.useForm()
  const { selectedVehicleName } = useVehicles()

  const CSV_OPTIONS = [
    { value: 'wire_list', label: intl.formatMessage({ id: 'csvDependencies.wireList' }) },
    { value: 'dtcs', label: intl.formatMessage({ id: 'csvDependencies.dtcs' }) },
    { value: 'dtcs_dependencies', label: intl.formatMessage({ id: 'csvDependencies.dtcsDependencies' }) },
    { value: 'modules', label: intl.formatMessage({ id: 'csvDependencies.modules' }) },
    { value: 'inlines', label: intl.formatMessage({ id: 'csvDependencies.inlines' }) },
    { value: 'harness_description', label: intl.formatMessage({ id: 'csvDependencies.harnessDescription' }) },
    { value: 'sig_list', label: intl.formatMessage({ id: 'csvDependencies.sigList' }) },
    { value: 'sales_codes', label: intl.formatMessage({ id: 'csvDependencies.salesCodes' }) },
    { value: 'sales_code_constraints', label: intl.formatMessage({ id: 'csvDependencies.salesCodeConstraints' }) },
    { value: 'connector_layout', label: intl.formatMessage({ id: 'csvDependencies.connectorLayout' }) },
    { value: 'device_connections', label: intl.formatMessage({ id: 'csvDependencies.deviceConnections' }) },
    { value: 'power_distributions', label: intl.formatMessage({ id: 'csvDependencies.powerDistributions' }) },
    { value: 'component_list', label: intl.formatMessage({ id: 'csvDependencies.componentList' }) },
    { value: 'functional_diagram', label: intl.formatMessage({ id: 'csvDependencies.functionalDiagram' }) },
  ]

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({ id: 'layout.adminTools' }),
        sub_header: vehicle
          ? intl.formatMessage({ id: 'layout.vehicleList' }) + ` / ${selectedVehicleName} / ` + intl.formatMessage({ id: 'csvDependencies.title' })
          : '',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        vehicle: vehicle,
        full_width_container: false,
      },
    })
  }, [])

  useEffect(() => {
    if (make_model_id && metadata) {
      setSelectedValue(metadata)
      form.setFieldsValue(metadata)
    }
  }, [props.vehicleDetails])

  const saveCsvDependency = async (values) => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'csvDependencies.saving' }),
        showLoader: true,
      },
      notification: {},
    })

    let res = await putRequest(
      `/api/vehicles/save_csv_dependency/${vehicle}/`,
      values
    )

    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: intl.formatMessage({ id: 'csvDependencies.saveSuccess' }),
      },
    })
  }

  return (
    <>
      <div className="vehicle-form csv-dependencies-wrapper">
        <Form
          id="vehicle-form-csv-dependencies"
          name="vehicle-form-csv-dependencies"
          form={form}
          layout="vertical"
          onFinish={saveCsvDependency}
        >
          <Card title="" variant="outlined">
            <Flex
              style={{ paddingTop: 16, paddingBottom: 16 }}
              vertical
              gap={16}
            >
              {CSV_OPTIONS.map((dependency) => {
                return (
                  <SelectInput
                    key={dependency.value}
                    name={dependency.value}
                    isRequired={false}
                    label={dependency.label}
                    isMulti={true}
                    options={CSV_OPTIONS}
                    placeholder={intl.formatMessage({ id: 'csvDependencies.selectDependency' })}
                    onChange={(value) => {
                      setSelectedValue({
                        ...selectedValue,
                        [dependency.value]: value,
                      })
                    }}
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omittedValues) => (
                      <Tooltip title={omittedValues.map((v) => v.label).join(', ')}>
                        <span>+{omittedValues.length}</span>
                      </Tooltip>
                    )}
                  />
                )
              })}
            </Flex>
          </Card>
          <Button htmlType="submit" type="primary" testId="csv-dependencies-save">
            {intl.formatMessage({ id: 'csvDependencies.saveButton' })}
          </Button>
        </Form>
      </div>
    </>
  )
}

export default CsvDependencies
